/* ================================================================
   CUSTOM JS — Maius
   ================================================================ */

/* ─────────────────────────────────────
   i18n — çeviriler theme.liquid'de window.maius.t içine "| t" ile gömülür.
   maiusT(key, fallback): anahtar yoksa fallback (Türkçe) döner → güvenli.
───────────────────────────────────── */
function maiusT(key, fallback) {
  var t = (window.maius && window.maius.t) || {};
  return (t[key] != null && t[key] !== '') ? t[key] : fallback;
}

/* ─────────────────────────────────────
   Arama overlay genişliğini menüye (ilk öğe -> son öğe) göre ayarla.
   Menü ortalı olduğu için bu konum dinamiktir; ölçüp uyguluyoruz.
───────────────────────────────────── */

(function () {
  function alignSearchArea() {
    var items = document.querySelectorAll('.header__primary-nav-item');
    if (!items.length) return;

    var first = items[0].getBoundingClientRect();
    var last = items[items.length - 1].getBoundingClientRect();
    if (first.width === 0) return; // menü mobilde gizli

    var root = document.documentElement;
    root.style.setProperty('--search-area-left', first.left + 'px');
    root.style.setProperty('--search-area-width', (last.right - first.left) + 'px');
  }

  /* Bildirim popup: bell ikonuna tıklayınca aç, X / backdrop / Esc ile kapat */
  function initNotificationPopup() {
    var trigger = document.querySelector('[data-notification-open]');
    var popup = document.getElementById('notification-popup');
    if (!trigger || !popup || typeof popup.showModal !== 'function') return;

    trigger.addEventListener('click', function () {
      popup.showModal();
    });

    popup.querySelectorAll('[data-notification-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        popup.close();
      });
    });

    // Kart dışına (backdrop) tıklayınca kapat
    popup.addEventListener('click', function (event) {
      if (event.target === popup) popup.close();
    });
  }

  function init() {
    alignSearchArea();
    window.addEventListener('resize', alignSearchArea);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(alignSearchArea);
    }
    initNotificationPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────
   SIZE ÖZEL — kişisel öneri widget'ı
   Son gezilen ürünle tetiklenir; "Son Gezilenler" + "Alternatifler".
───────────────────────────────────── */

(function () {
  var RECENT_KEY = 'theme:recently-viewed-products';
  var COLLAPSE_KEY = 'pw-collapsed';

  function init() {
    var widget = document.querySelector('personal-widget');
    if (!widget) return;

    var ids;
    try {
      ids = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    } catch (e) {
      ids = [];
    }
    if (!ids.length) return; // son gezilen ürün yok → widget gizli kalır

    var recentIds = ids.slice(0, 12);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var trigger = widget.querySelector('[data-pw-open]');
    var panel = widget.querySelector('[data-pw-panel]');
    var thumb = widget.querySelector('[data-pw-thumb]');
    var recentPanel = widget.querySelector('[data-pw-tabpanel="recent"]');
    var altPanel = widget.querySelector('[data-pw-tabpanel="alt"]');

    function extractResults(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('[data-pw-results]');
    }

    // Son gezilenleri yükle
    var query = recentIds
      .map(function (id) { return 'id:' + id; })
      .join(' OR ');

    fetch(root + 'search?type=product&q=' + encodeURIComponent(query) + '&section_id=personal-widget', { priority: 'low' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var results = extractResults(html);
        if (results && results.children.length) {
          recentPanel.innerHTML = results.outerHTML;
          var firstImg = recentPanel.querySelector('img');
          if (firstImg) {
            thumb.style.backgroundImage = 'url("' + firstImg.src + '")';
          }
          if (sessionStorage.getItem(COLLAPSE_KEY) === '1') {
            widget.classList.add('is-collapsed');
          }
          widget.hidden = false;
        }
      })
      .catch(function () {});

    // Alternatifler — her açılışta yeniden çekilir (sürekli güncel), 12 adet
    function loadAlternatives() {
      altPanel.innerHTML = '<p class="personal-widget__state">' + maiusT('loading', 'Yükleniyor…') + '</p>';

      fetch(root + 'recommendations/products?product_id=' + recentIds[0] + '&intent=related&limit=12&section_id=personal-widget', { priority: 'low' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var results = extractResults(html);
          if (results && results.children.length) {
            altPanel.innerHTML = results.outerHTML;
          } else {
            altPanel.innerHTML = '<p class="personal-widget__state">' + maiusT('pw_empty', 'Öneri bulunamadı.') + '</p>';
          }
        })
        .catch(function () {
          altPanel.innerHTML = '<p class="personal-widget__state">' + maiusT('pw_error', 'Öneriler yüklenemedi.') + '</p>';
        });
    }

    function openPanel() {
      panel.hidden = false;
      widget.classList.add('is-open');
    }
    function closePanel() {
      panel.hidden = true;
      widget.classList.remove('is-open');
    }

    trigger.addEventListener('click', function () {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    widget.querySelector('[data-pw-close]').addEventListener('click', closePanel);

    // Kapat: tamamen gizleme yerine sola yapışan sekmeye küçült
    widget.querySelector('[data-pw-dismiss]').addEventListener('click', function () {
      closePanel();
      widget.classList.add('is-collapsed');
      sessionStorage.setItem(COLLAPSE_KEY, '1');
    });

    // İnce sekmeye tıklayınca tetikleyici butona dön (panel kapalı kalır)
    widget.querySelector('[data-pw-expand]').addEventListener('click', function () {
      closePanel();
      widget.classList.remove('is-collapsed');
      sessionStorage.removeItem(COLLAPSE_KEY);
    });

    var tabs = widget.querySelectorAll('[data-pw-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-pw-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        recentPanel.hidden = name !== 'recent';
        altPanel.hidden = name !== 'alt';
        if (name === 'alt') loadAlternatives();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────
   ÜRÜN KARTI — fare konumuyla görsel galerisi
   Kart görseli üzerinde fareyi yatayda kaydırdıkça (en fazla 4) görsel değişir.
───────────────────────────────────── */

(function () {
  function setActive(media, index) {
    var imgs = media.querySelectorAll('.product-card__image');
    for (var i = 0; i < imgs.length; i++) {
      if (i === index) {
        imgs[i].setAttribute('data-gallery-active', 'true');
      } else {
        imgs[i].removeAttribute('data-gallery-active');
      }
    }
  }

  function attach(media) {
    if (media.closest('product-card')) return; // tüm kartlarda kaydırmalı galeri var (İpekyol standardı)
    if (media.dataset.galleryReady) return;
    media.dataset.galleryReady = '1';

    media.addEventListener('mousemove', function (e) {
      var imgs = media.querySelectorAll('.product-card__image');
      if (imgs.length < 2) return;
      var rect = media.getBoundingClientRect();
      if (rect.width === 0) return;
      var zone = Math.floor((e.clientX - rect.left) / rect.width * imgs.length);
      if (zone < 0) zone = 0;
      if (zone > imgs.length - 1) zone = imgs.length - 1;
      setActive(media, zone);
    });

    media.addEventListener('mouseleave', function () {
      setActive(media, 0);
    });
  }

  function init() {
    // Kart üzerine ilk gelindiğinde bağla — dinamik eklenen kartları da kapsar
    document.addEventListener('mouseover', function (e) {
      var media = e.target.closest && e.target.closest('.product-card__media');
      if (media) attach(media);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────
   CART — Recently viewed bar
   Sepet sayfasında "Bunlar da ilginizi çekebilir" carousel'ı.
───────────────────────────────────── */

(function () {
  function init() {
    var widget = document.querySelector('[data-cart-recently-viewed]');
    if (!widget) return;

    var ids;
    try {
      ids = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
    } catch (e) { ids = []; }

    if (!ids.length) return; // hiç ürün gezilmemişse gizli kalır

    var body = widget.querySelector('[data-cart-recently-viewed-body]');
    if (!body) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var MAX = 8;
    var queryIds = ids.slice(0, MAX);
    var query = queryIds.map(function (id) { return 'id:' + id; }).join(' OR ');

    fetch(root + 'search?type=product&q=' + encodeURIComponent(query) + '&resources[limit]=' + MAX + '&section_id=personal-widget', { priority: 'low' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = doc.querySelector('[data-pw-results]');
        if (results && results.children.length) {
          body.innerHTML = results.outerHTML;
          widget.hidden = false;
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────
   BEDEN TABLOSU MODAL — accordion içindeki linki popup'a çevir
───────────────────────────────────── */

(function () {
  function getModal() {
    return document.getElementById('maius-size-guide-modal');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-size-guide-trigger], a[href="/pages/beden-tablosu"]');
    if (!trigger) return;

    var modal = getModal();
    if (!modal) return; // modal yoksa link normal çalışsın

    e.preventDefault();
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  });

  document.addEventListener('click', function (e) {
    var modal = getModal();
    if (!modal || !modal.open) return;

    if (e.target.closest && e.target.closest('[data-size-guide-close]')) {
      e.preventDefault();
      modal.close();
      return;
    }
    // Backdrop click → kapat
    if (e.target === modal) {
      modal.close();
    }
  });
})();

/* ─────────────────────────────────────
   KVKK / Cookie Consent Banner
   localStorage key: maius:cookie-consent → 'accepted' | 'rejected'
   window.maiusCookieConsent === true → analytics tetiklenebilir
───────────────────────────────────── */

(function () {
  var KEY = 'maius:cookie-consent';
  var stored = null;
  try { stored = localStorage.getItem(KEY); } catch (_) {}

  // Global API: analytics script'leri buna bağlanır
  window.maiusCookieConsent = stored === 'accepted';

  function showBanner() {
    var banner = document.getElementById('maius-cookie-banner');
    if (!banner) return;
    requestAnimationFrame(function () {
      banner.hidden = false;
      requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
    });
  }

  function hideBanner() {
    var banner = document.getElementById('maius-cookie-banner');
    if (!banner) return;
    banner.classList.remove('is-visible');
    setTimeout(function () { banner.hidden = true; }, 350);
  }

  function setConsent(value) {
    try { localStorage.setItem(KEY, value); } catch (_) {}
    window.maiusCookieConsent = value === 'accepted';
    hideBanner();
    // Consent değişti event'i — analytics modülleri dinleyebilir
    document.dispatchEvent(new CustomEvent('maius:consent-change', {
      detail: { consent: value }
    }));
  }

  function init() {
    // Henüz karar verilmediyse banner göster (kısa gecikme ile, sayfa yerleşsin)
    if (!stored) {
      setTimeout(showBanner, 600);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cookie-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-cookie-action');
      if (action === 'accept') setConsent('accepted');
      else if (action === 'reject') setConsent('rejected');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* [KALDIRILDI 2026-09-27 denetim] FLY-TO-CART animasyonu: blok C:/Claude/maius-tema/arsiv/custom-arsiv.js (tema dışı) dosyasına taşındı */

/* [KALDIRILDI 2026-09-27 denetim] PAGE TRANSITIONS fallback (her tıklamada 220 ms gecikme): blok C:/Claude/maius-tema/arsiv/custom-arsiv.js (tema dışı) dosyasına taşındı */

/* ─────────────────────────────────────
   SLIDESHOW — desktop mouse-drag fix
   Native image/link drag pointer event zincirini kesip slideshow swipe'ı
   devre dışı bırakıyor. Slideshow içindeki tüm dragstart event'lerini
   yakalayıp engelliyoruz.
───────────────────────────────────── */

(function () {
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.closest && e.target.closest('.slideshow')) {
      e.preventDefault();
    }
  }, true);
})();

/* ─────────────────────────────────────
   WISHLIST — favori listesi (localStorage tabanlı)
   Favori butonu ürün kartında; "Favori Listeniz" kartı sepet sayfasında.
───────────────────────────────────── */

(function () {
  var KEY = 'theme:wishlist';
  var favoritesEmptyHtml = null;

  function get() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function save(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
  }

  function syncSidebarBadge() {
    var badge = document.getElementById('sidebar-wishlist-badge');
    if (!badge) return;
    var ids = get();
    if (ids.length) {
      badge.textContent = ids.length;
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
  }

  function syncButtons() {
    var ids = get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = parseInt(btn.getAttribute('data-product-id'), 10);
      var active = ids.indexOf(id) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    syncSidebarBadge();
  }

  function renderFavorites() {
    var container = document.querySelector('[data-cart-favorites]');
    if (!container) return;

    var body = container.querySelector('[data-cart-favorites-body]');
    var countEl = container.querySelector('[data-cart-favorites-count]');

    // İlk çağrıda Liquid'in koyduğu boş-durum HTML'ini sakla
    if (favoritesEmptyHtml === null) {
      favoritesEmptyHtml = body.innerHTML;
    }

    var ids = get();

    if (countEl) countEl.textContent = '(' + ids.length + ' ' + maiusT('items', 'Ürün') + ')';

    if (!ids.length) {
      body.innerHTML = favoritesEmptyHtml;
      return;
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var MAX = 50; // wishlist sayfasında gösterilecek azami favori sayısı
    var queryIds = ids.slice(0, MAX);
    var query = queryIds.map(function (id) { return 'id:' + id; }).join(' OR ');

    fetch(root + 'search?type=product&q=' + encodeURIComponent(query) + '&resources[limit]=' + MAX + '&section_id=personal-widget', { priority: 'low' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = doc.querySelector('[data-pw-results]');
        if (results && results.children.length) {
          body.innerHTML = results.outerHTML;
          // Hangi product ID'leri geldi → localStorage'ı sadece bunlara göre güncelle
          var validIds = [];
          results.querySelectorAll('[data-product-id]').forEach(function (el) {
            var pid = parseInt(el.getAttribute('data-product-id'), 10);
            if (pid && ids.indexOf(pid) !== -1 && validIds.indexOf(pid) === -1) {
              validIds.push(pid);
            }
          });
          // Eğer bazı favori ID'leri yetim çıktıysa (ürün silinmiş/unpublished), localStorage'ı temizle
          if (validIds.length && validIds.length < ids.length) {
            save(validIds);
            if (countEl) countEl.textContent = '(' + validIds.length + ' ' + maiusT('items', 'Ürün') + ')';
          }
          // Yeni enjekte edilen kalp butonlarını aktif duruma çek
          syncButtons();
        } else {
          // Hiç sonuç gelmedi → tüm ID'ler yetim, localStorage'ı sıfırla ve boş durumu göster
          save([]);
          if (countEl) countEl.textContent = '(0 ' + maiusT('items', 'Ürün') + ')';
          body.innerHTML = favoritesEmptyHtml;
          syncButtons();
        }
      })
      .catch(function () {});
  }

  function init() {
    syncButtons();
    renderFavorites();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();

      var id = parseInt(btn.getAttribute('data-product-id'), 10);
      if (!id) return;

      var ids = get();
      var idx = ids.indexOf(id);
      if (idx === -1) {
        ids.push(id);
      } else {
        ids.splice(idx, 1);
      }
      save(ids);
      syncButtons();
      renderFavorites();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================
 * Stok aciliyet — varyant değiştikçe güncelle.
 * Veri kaynağı: stock-urgency.liquid'in gömdüğü data-inventory.
 * (Storefront .js, inventory_quantity vermediği için .js fetch KULLANILMAZ;
 *  eski sürüm bu yüzden uyarıyı her varyant değişiminde gizliyordu.)
 * ========================================================= */
(function () {
  function applyUrgency(urgencyEl, variantId) {
    if (!urgencyEl) return;
    var textEl = urgencyEl.querySelector('.product-stock-urgency__text');
    var lowTpl = urgencyEl.getAttribute('data-low-text') || maiusT('low_stock_html', 'Son %qty% adet kaldı!');

    var map = {};
    try { map = JSON.parse(urgencyEl.getAttribute('data-inventory') || '{}'); } catch (e) {}
    var qty = parseInt(map[variantId], 10);
    if (isNaN(qty)) qty = 0;

    if (qty > 0) {
      urgencyEl.classList.remove('hidden');
      if (textEl) textEl.textContent = lowTpl.replace('%qty%', qty);
    } else {
      urgencyEl.classList.add('hidden');
      if (textEl) textEl.textContent = '';
    }
  }

  function initStockUrgency() {
    document.querySelectorAll('product-stock-urgency').forEach(function (urgencyEl) {
      var scope = urgencyEl.closest('product-info, .product-info, section') || document;
      var form = scope.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      function refresh() {
        // Öğeyi/inputu her seferinde yeniden bul (product-rerender değiştirebilir).
        var el = scope.querySelector('product-stock-urgency') || urgencyEl;
        var input = form.querySelector('input[name="id"]');
        if (!input || !input.value) return;
        applyUrgency(el, input.value);
      }

      var input = form.querySelector('input[name="id"]');
      if (input) {
        new MutationObserver(refresh).observe(input, { attributes: true, attributeFilter: ['value'] });
        input.addEventListener('change', refresh);
      }
      form.addEventListener('change', function () { setTimeout(refresh, 50); });

      refresh(); // ilk yüklemede de eşitle
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStockUrgency);
  } else {
    initStockUrgency();
  }
})();

/* =========================================================
 * Sıkça birlikte alınan (FBT)
 * ========================================================= */
(function () {
  function formatMoney(cents) {
    // Shopify money formatlamasını basitçe taklit eder
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}} TL');
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    // Binlik ayırıcı
    var parts = amount.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' TL';
  }

  function updateTotals(widget) {
    var toggles = widget.querySelectorAll('[data-fbt-toggle]');
    var totalPrice = 0;
    var totalCompare = 0;
    var selectedCount = 0;
    var hasDiscount = false;

    toggles.forEach(function (t) {
      if (t.getAttribute('aria-checked') === 'true') {
        var price = parseInt(t.getAttribute('data-price'), 10) || 0;
        var compare = parseInt(t.getAttribute('data-compare-price'), 10) || 0;
        totalPrice += price;
        totalCompare += compare > price ? compare : price;
        if (compare > price) hasDiscount = true;
        selectedCount += 1;
      }
    });

    var totalEl = widget.querySelector('[data-fbt-total]');
    var origEl = widget.querySelector('[data-fbt-original]');
    var btn = widget.querySelector('[data-fbt-add]');

    if (totalEl) totalEl.textContent = formatMoney(totalPrice);

    if (origEl) {
      if (hasDiscount && totalCompare > totalPrice) {
        origEl.textContent = formatMoney(totalCompare);
        origEl.hidden = false;
      } else {
        origEl.hidden = true;
      }
    }

    if (btn) {
      btn.disabled = selectedCount === 0;
    }
  }

  function addAllToCart(widget) {
    var btn = widget.querySelector('[data-fbt-add]');
    var labelEl = widget.querySelector('[data-fbt-add-label]');
    if (!btn || btn.disabled) return;

    var toggles = widget.querySelectorAll('[data-fbt-toggle]');
    var items = [];
    toggles.forEach(function (t) {
      if (t.getAttribute('aria-checked') === 'true') {
        var id = parseInt(t.getAttribute('data-variant-id'), 10);
        if (id) items.push({ id: id, quantity: 1 });
      }
    });
    if (!items.length) return;

    var originalLabel = labelEl ? labelEl.textContent : '';
    btn.classList.add('is-loading');
    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Ekleniyor...';

    // Prestige cart pattern:
    // 1. cart:prepare-bundled-sections eventiyle hangi section'ların render edileceğini topla
    // 2. /cart/add.js'e sections=... ile POST → response'da rendered HTML
    // 3. /cart.js'i çek → cart objesine sections'ı merge et
    // 4. cart:change eventini documentElement'te dispatch et (baseEvent: variant:add)
    // CartDrawer bu eventi yakalayıp kendini yeniler ve drawer mode'sa otomatik açar.

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    var addFormData = new FormData();
    items.forEach(function (it, i) {
      addFormData.append('items[' + i + '][id]', it.id);
      addFormData.append('items[' + i + '][quantity]', it.quantity);
    });
    if (sectionsToBundle.length) {
      addFormData.set('sections', sectionsToBundle.join(','));
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: addFormData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function (addResponse) {
        if (labelEl) labelEl.textContent = 'Eklendi!';
        // /cart.js'ten tam cart objesini çek, response'taki sections'ı ekle
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = addResponse.sections || {};
            // Prestige'in beklediği şekilde cart:change dispatch et
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  cart: cart
                }
              })
            );
            // Header'daki sepet sayacını da explicit güncelle (badge'ler)
            document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            setTimeout(function () {
              btn.classList.remove('is-loading');
              btn.disabled = false;
              if (labelEl) labelEl.textContent = originalLabel;
            }, 1200);
          });
      })
      .catch(function () {
        if (labelEl) labelEl.textContent = maiusT('error_retry', 'Hata, tekrar dene');
        setTimeout(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (labelEl) labelEl.textContent = originalLabel;
        }, 1800);
      });
  }

  function init() {
    var widgets = document.querySelectorAll('fbt-widget');
    if (!widgets.length) return;

    widgets.forEach(function (widget) {
      // Başlangıçta toplamı hesapla
      updateTotals(widget);

      // Check toggle
      widget.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-fbt-toggle]');
        if (toggle) {
          var current = toggle.getAttribute('aria-checked') === 'true';
          toggle.setAttribute('aria-checked', current ? 'false' : 'true');
          updateTotals(widget);
          return;
        }

        var addBtn = e.target.closest('[data-fbt-add]');
        if (addBtn) {
          e.preventDefault();
          addAllToCart(widget);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================
 * Stoğa gelince haber ver
 * ========================================================= */
(function () {
  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function refreshAvailability(bisEl) {
    var handle = getProductHandle();
    if (!handle) return;

    var section = bisEl.closest('product-info, .product-info, section') || document;
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;

    var variantId = variantInput.value;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants) return;
        var v = data.variants.find(function (x) { return String(x.id) === String(variantId); });
        if (!v) return;

        bisEl.setAttribute('data-variant-id', v.id);

        if (v.available) {
          bisEl.classList.add('hidden');
        } else {
          bisEl.classList.remove('hidden');
        }
      })
      .catch(function () {});
  }

  function bindForm(bisEl) {
    var modal = bisEl.querySelector('[data-bis-modal]');
    var form = bisEl.querySelector('[data-bis-form]');
    var submitBtn = bisEl.querySelector('[data-bis-submit]');
    var submitLabel = bisEl.querySelector('[data-bis-submit-label]');
    var successEl = bisEl.querySelector('[data-bis-success]');
    var errorEl = bisEl.querySelector('[data-bis-error]');
    var emailInput = bisEl.querySelector('[data-bis-email]');

    if (!modal || !form) return;

    bisEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-bis-open]')) {
        e.preventDefault();
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
      }
      if (e.target.closest('[data-bis-close]')) {
        e.preventDefault();
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      }
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!emailInput || !emailInput.value || !emailInput.checkValidity()) {
        if (emailInput) emailInput.focus();
        return;
      }

      var variantId = bisEl.getAttribute('data-variant-id') || '';
      var productTitle = bisEl.getAttribute('data-product-title') || '';

      // Liquid {% form 'contact' %} zaten authenticity_token, form_type, utf8 ekler.
      // new FormData(form) ile bu hidden fieldları da alıyoruz → CSRF sorunu yok.
      var formData = new FormData(form);

      // Varyant ID'yi güncel değerle güncelle (JS tarafından track edilen)
      formData.set('contact[Varyant_ID]', variantId);
      formData.set('contact[body]',
        'Ürün: ' + productTitle + '\n' +
        'Varyant ID: ' + variantId + '\n' +
        'Sayfa: ' + window.location.href
      );

      submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = maiusT('bis_submitting', 'Gönderiliyor...');
      if (errorEl) errorEl.hidden = true;

      // Shopify /contact → 302 redirect döner (opaque response).
      // Response içeriğini okuyamayız; fetch resolve olursa = gönderim başarılı.
      // Sadece gerçek network hatası (offline, bağlantı yok) catch'e düşer.
      fetch('/contact', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        redirect: 'manual'
      })
        .then(function () {
          form.querySelectorAll('input, button[type="submit"], .back-in-stock-modal__text, .back-in-stock-modal__field').forEach(function (el) {
            el.style.display = 'none';
          });
          if (successEl) successEl.hidden = false;
        })
        .catch(function () {
          if (errorEl) {
            errorEl.textContent = maiusT('bis_error', 'Bir hata oluştu. Lütfen tekrar deneyin.');
            errorEl.hidden = false;
          }
          submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = maiusT('bis_submit', 'Beni Bilgilendir');
        });
    });
  }

  function initBackInStock() {
    var els = document.querySelectorAll('back-in-stock');
    if (!els.length) return;

    els.forEach(function (bisEl) {
      bindForm(bisEl);
      refreshAvailability(bisEl);

      var section = bisEl.closest('product-info, .product-info, section') || document;
      var form = section.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        var observer = new MutationObserver(function () { refreshAvailability(bisEl); });
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        variantInput.addEventListener('change', function () { refreshAvailability(bisEl); });
      }

      form.addEventListener('change', function () {
        setTimeout(function () { refreshAvailability(bisEl); }, 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackInStock);
  } else {
    initBackInStock();
  }
})();

/* ─────────────────────────────────────
   Ürünü Paylaş — link kopyalama
───────────────────────────────────── */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-copy]');
    if (!btn) return;

    var url = btn.getAttribute('data-url') || window.location.href;
    var tooltip = btn.querySelector('.product-share__copied');

    navigator.clipboard.writeText(url).then(function () {
      if (!tooltip) return;
      tooltip.hidden = false;
      setTimeout(function () { tooltip.hidden = true; }, 2000);
    }).catch(function () {
      // Fallback: execCommand
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      if (!tooltip) return;
      tooltip.hidden = false;
      setTimeout(function () { tooltip.hidden = true; }, 2000);
    });
  });
})();

/* ─────────────────────────────────────
   Arama overlay'i açıldığında açık olan menüleri (mega-menü / dropdown) kapat.
   Menüler "hover" ile açıldığından, arama kutusu açılınca açık kalabiliyordu.
───────────────────────────────────── */
(function () {
  function closeOpenMenus() {
    document
      .querySelectorAll('mega-menu-disclosure, dropdown-menu-disclosure')
      .forEach(function (el) {
        try {
          var details = el.querySelector('details[open]');
          if (!details) return;
          // Önce bileşenin kendi kapanışı (animasyon + durum temizliği)
          if (typeof el.close === 'function') el.close();
          // Güvence: bileşen kapatmazsa native olarak kapat
          details.open = false;
        } catch (e) {}
      });
  }

  // header-search dialog'u açılmadan hemen önce tetiklenir.
  // "dialog:before-show" baloncuklanmayabileceği için capture aşamasında dinliyoruz.
  document.addEventListener(
    'dialog:before-show',
    function (event) {
      var t = event.target;
      if (t && t.tagName === 'HEADER-SEARCH') {
        closeOpenMenus();
      }
    },
    true
  );
})();

/* ─────────────────────────────────────
   ÜRÜN KARTI — düşük-stok rozetini seçilen renge (varyanta) göre güncelle.
   Swatch input'unda data-low-stock = stok 1-3 ise o miktar, değilse 0.
   Renk değişince rozet güncellenir; düşük değilse gizlenir, geri dönülünce
   tekrar gösterilir. (Önceden rozet ilk varyanta sabitti ve güncellenmiyordu.)
───────────────────────────────────── */
(function () {
  function updateCardLowStock(card, qty) {
    var badge = card.querySelector('.badge--low-stock');

    if (qty > 0) {
      if (!badge) {
        var list = card.querySelector('.badge-list');
        if (!list) {
          var figure = card.querySelector('.product-card__figure') || card;
          list = document.createElement('badge-list');
          list.className = 'badge-list badge-list--vertical';
          figure.insertBefore(list, figure.firstChild);
        }
        badge = document.createElement('span');
        badge.className = 'badge badge--maius badge--low-stock';
        list.insertBefore(badge, list.firstChild);
      }
      badge.hidden = false;
      badge.style.removeProperty('display');
      badge.textContent = 'Son ' + qty + ' adet';
    } else if (badge) {
      badge.remove();
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || typeof input.matches !== 'function' || !input.matches('input[data-low-stock]')) return;
    var card = input.closest('.product-card');
    if (!card) return;
    var qty = parseInt(input.getAttribute('data-low-stock'), 10);
    if (isNaN(qty)) qty = 0;
    updateCardLowStock(card, qty);
  });
})();

/* ─────────────────────────────────────
   Menü: animasyonsuz, anında açılır (Alperen 2026-09-26)
   Temanın mega menü ve açılır menü bileşenleri açılırken önce 0,25 sn
   saydamlaşıp sonra alt başlıkları tek tek (0,1 sn arayla) kaydırıyordu.
   theme.js'e dokunmadan bu iki bileşenin açma/kapama davranışı
   burada anında olacak şekilde değiştirilir.
───────────────────────────────────── */
(function () {
  var ANINDA_KAPAT = { finished: Promise.resolve(true), finish: function () {}, cancel: function () {} };

  function anindaYap(etiket) {
    customElements.whenDefined(etiket).then(function () {
      var Sinif = customElements.get(etiket);
      if (!Sinif || Sinif.prototype.__maiusAninda) return;
      var asilAc = Sinif.prototype.open;
      Sinif.prototype.open = function () {
        var sonuc = asilAc.call(this, { instant: true });
        var icerik = this.contentElement;
        if (icerik) {
          icerik.style.opacity = '1';
          icerik.querySelectorAll('.mega-menu__linklist > li, :scope > li, .mega-menu__promo').forEach(function (el) {
            el.style.opacity = '1';
            el.style.transform = 'none';
          });
        }
        return sonuc;
      };
      Sinif.prototype.createHideAnimationControls = function () {
        return ANINDA_KAPAT;
      };
      Sinif.prototype.__maiusAninda = true;
    });
  }

  anindaYap('mega-menu-disclosure');
  anindaYap('dropdown-menu-disclosure');
})();

/* ─────────────────────────────────────
   KOLEKSİYON — kaydırmalı kart galerisi (İpekyol düzeni, 2026-09-26)
   Görseller bir şeritte durur; şerit transform ile kayar.
   Sürüklerken görsel parmağı/fareyi takip eder, bırakınca 300 ms "ease"
   ile yerine oturur (İpekyol'da ölçülen değer). Yarısından fazla ya da
   hızlı kaydırınca sonraki görsele geçer, yoksa geri döner.
───────────────────────────────────── */
(function () {
  var SURE = 300;
  var EGRI = 'ease';
  var OK_SOL = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15 18-6-6 6-6"/></svg>';
  var OK_SAG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 18 6-6-6-6"/></svg>';

  function setup(card) {
    if (card.dataset.ipkGallery) return;
    var figure = card.querySelector('.product-card__figure');
    var media = card.querySelector('.product-card__media');
    if (!figure || !media) return;
    card.dataset.ipkGallery = '1';

    var imgs = Array.prototype.slice.call(media.querySelectorAll('.product-card__image'));
    var n = imgs.length;

    // Oranı kartla uyuşmayan fotoğraf kesilmesin: tamamı gösterilir, boşluk beyaz.
    // (Maius fotoğraflarının çoğu 4:5; 2:3, 1,4 ve kare olanlar kesiliyordu.)
    // Karar fotoğrafın kenarına bakılarak verilir:
    //  - kenarları düz açık renk (stüdyo fonu) -> tamamı gösterilir, boşluk fonun kendi rengiyle
    //    doldurulur, yani boşluk görünmez;
    //  - ev içi / dış çekim -> kartı doldurur (hafif kırpılır), beyaz şerit kalmaz.
    var KUTU = 1.25;
    function fonRengi(img) {
      try {
        var cw = 24, ch = 30, c = document.createElement('canvas');
        c.width = cw; c.height = ch;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, cw, ch);
        var d = x.getImageData(0, 0, cw, ch).data;
        var r = 0, g = 0, b = 0, n = 0, lo = 255, hi = 0;
        function px(i, j) {
          var k = (j * cw + i) * 4, L = (d[k] + d[k + 1] + d[k + 2]) / 3;
          r += d[k]; g += d[k + 1]; b += d[k + 2]; n++;
          if (L < lo) lo = L; if (L > hi) hi = L;
        }
        for (var j = 0; j < ch; j++) { px(0, j); px(1, j); px(cw - 1, j); px(cw - 2, j); }
        for (var i = 0; i < cw; i++) { px(i, 0); px(i, 1); px(i, ch - 1); px(i, ch - 2); }
        if (hi - lo > 18 || lo < 205) return null;
        return 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
      } catch (e) { return null; }
    }
    function yerlestir(img) {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h || Math.abs(h / w - KUTU) <= 0.06) return;
      var fon = fonRengi(img);
      if (fon) { img.classList.add('ipk-fit-contain'); img.style.backgroundColor = fon; }
      else { img.classList.remove('ipk-fit-contain'); img.style.backgroundColor = ''; }
    }
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth) yerlestir(img);
      img.addEventListener('load', function () { yerlestir(img); });
    });

    if (n < 2) return;

    var track = document.createElement('div');
    track.className = 'ipk-gallery-track';
    imgs.forEach(function (img) { track.appendChild(img); });
    media.appendChild(track);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'ipk-gallery-arrow ipk-gallery-arrow--prev';
    prev.setAttribute('aria-label', maiusT('gallery_prev', 'Önceki görsel'));
    prev.innerHTML = OK_SOL;
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'ipk-gallery-arrow ipk-gallery-arrow--next';
    next.setAttribute('aria-label', maiusT('gallery_next', 'Sonraki görsel'));
    next.innerHTML = OK_SAG;
    var bar = document.createElement('div');
    bar.className = 'ipk-gallery-bar';
    var fill = document.createElement('span');
    fill.className = 'ipk-gallery-bar__fill';
    bar.appendChild(fill);
    figure.appendChild(prev);
    figure.appendChild(next);
    figure.appendChild(bar);

    var index = 0;

    // Tarayıcının kendi "bağlantıyı sürükle" davranışı: gerçek Chrome'da fareyle
    // çekince kartın yarı saydam bir kopyası imleçle gezer ve pointer olayları
    // kesilir (görsel soluk görünür, yarıda kalır). Tamamen kapatılır.
    media.setAttribute('draggable', 'false');
    imgs.forEach(function (img) { img.setAttribute('draggable', 'false'); });
    media.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function render(animate, offsetPx) {
      track.style.transition = animate ? 'transform ' + SURE + 'ms ' + EGRI : 'none';
      track.style.transform = 'translate3d(calc(' + (-index * 100) + '% + ' + (offsetPx || 0) + 'px), 0, 0)';
      fill.style.transform = 'scaleX(' + ((index + 1) / n) + ')';
    }

    function goTo(i) {
      index = (i + n) % n;
      render(true, 0);
    }

    // Diğer görseller ilk etkileşimde hemen yüklensin (kayarken boş kare görünmesin)
    card.addEventListener('pointerenter', function () {
      imgs.forEach(function (img) { img.loading = 'eager'; });
    }, { once: true });

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(index - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(index + 1); });

    var down = false, yon = null, startX = 0, startY = 0, startT = 0, dx = 0, surukledi = false, pid = null;

    // Kaydırmalı şeritteki kartta sürükleme şeridi kaydırır; görsel oklarla değişir.
    if (card.closest('scroll-carousel')) { render(false, 0); return; }

    media.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; yon = null; dx = 0; surukledi = false; pid = e.pointerId;
      startX = e.clientX; startY = e.clientY; startT = performance.now();
      imgs.forEach(function (img) { img.loading = 'eager'; });
    });

    media.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var mx = e.clientX - startX, my = e.clientY - startY;
      if (yon === null) {
        if (Math.abs(mx) < 5 && Math.abs(my) < 5) return;
        yon = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (yon === 'x') {
          surukledi = true;
          media.classList.add('is-dragging');
          try { media.setPointerCapture(pid); } catch (_) {}
        }
      }
      if (yon !== 'x') return;
      dx = mx;
      var off = dx;
      if ((index === 0 && dx > 0) || (index === n - 1 && dx < 0)) off = dx * 0.35; // kenarda direnç
      render(false, off);
      e.preventDefault();
    });

    function bitir() {
      if (!down) return;
      down = false;
      media.classList.remove('is-dragging');
      if (yon !== 'x') return;
      var w = media.clientWidth || 1;
      var gecen = performance.now() - startT;
      var adim = 0;
      if (Math.abs(dx) > w * 0.5 || (gecen < 300 && Math.abs(dx) > 20)) adim = dx < 0 ? 1 : -1;
      index = Math.max(0, Math.min(n - 1, index + adim));
      render(true, 0);
    }

    media.addEventListener('pointerup', bitir);
    media.addEventListener('pointercancel', bitir);

    // Sürükleme sonrası ürüne gitme tıklamasını yut
    media.addEventListener('click', function (e) {
      if (surukledi) { e.preventDefault(); e.stopPropagation(); surukledi = false; }
    }, true);

    render(false, 0);
  }

  function init() {
    // Sitedeki tüm ürün kartları (kategori standardı)
    document.querySelectorAll('product-card').forEach(setup);
    // Sonradan gelen kartlar: filtre, sayfalama, sepet/favori/son bakılan, anlık arama
    var bekliyor = false;
    new MutationObserver(function () {
      if (bekliyor) return;
      bekliyor = true;
      requestAnimationFrame(function () {
        bekliyor = false;
        document.querySelectorAll('product-card:not([data-ipk-gallery])').forEach(setup);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────
   ANA SAYFA BANNER — yan oklar (İpekyol, 2026-09-26)
   Birden fazla slayt varsa banner'ın iki yanındaki boşluğa ok koyar.
   Temanın kendi slideshow-carousel previous()/next() geçişini kullanır.
───────────────────────────────────── */
(function () {
  var SOL = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15 18-6-6 6-6"/></svg>';
  var SAG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 18 6-6-6-6"/></svg>';

  function kur() {
    document.querySelectorAll('.shopify-section--slideshow slideshow-carousel').forEach(function (car) {
      if (car.dataset.ipkArrows) return;
      if (car.querySelectorAll('.slideshow__slide').length < 2) return;
      car.dataset.ipkArrows = '1';
      [['prev', SOL, 'Önceki', 'previous'], ['next', SAG, 'Sonraki', 'next']].forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ipk-banner-arrow ipk-banner-arrow--' + o[0];
        b.setAttribute('aria-label', o[2]);
        b.innerHTML = o[1];
        b.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof car[o[3]] === 'function') car[o[3]]();
        });
        car.appendChild(b);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }
  document.addEventListener('shopify:section:load', kur);
})();

/* ─────────────────────────────────────
   BEDEN TABLOSU LINKI — pop-up (2026-09-26)
   Urun sayfasindaki "Beden tablosunu goruntule" linki /pages/beden-tablosu
   sayfasina gitmek yerine temanin beden tablosu penceresini acar.
   Pencere sayfada yoksa (urunde beden secenegi yok) sayfanin icerigi
   cekilip ayni tipte bir pencerede gosterilir. Hata olursa link normal calisir.
   ───────────────────────────────────── */
(function () {
  if (window.__maiusSizeChartLink) return;
  window.__maiusSizeChartLink = true;

  var fallbackModal = null;

  function isChartLink(a) {
    if (!a || !a.getAttribute) return false;
    var href = a.getAttribute('href') || '';
    return /\/pages\/beden-tablosu\/?(\?|#|$)/.test(href);
  }

  function openModal(modal) {
    if (modal && typeof modal.show === 'function') {
      modal.show();
      return true;
    }
    return false;
  }

  function buildFallback(href) {
    return fetch(href, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('main .prose') || doc.querySelector('.prose') || doc.querySelector('main');
        if (!content) throw new Error('icerik yok');
        var title = (doc.querySelector('main h1') || {}).textContent || maiusT('size_guide_title', maiusT('size_guide_title', 'Beden Tablosu'));
        var m = document.createElement('x-modal');
        m.id = 'maius-size-chart-fallback';
        m.className = 'modal modal--lg color-scheme color-scheme--dialog';
        var h = document.createElement('span');
        h.className = 'h5';
        h.setAttribute('slot', 'header');
        h.textContent = title.trim();
        var body = document.createElement('div');
        body.className = 'prose';
        body.innerHTML = content.innerHTML;
        body.querySelectorAll('th, td').forEach(function (c) { if (!c.textContent.trim()) c.remove(); });
        m.appendChild(h);
        m.appendChild(body);
        document.body.appendChild(m);
        fallbackModal = m;
        return m;
      });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!isChartLink(a)) return;
    if (!document.querySelector('.shopify-section--main-product')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return; /* yeni sekmede acmak isteyene dokunma */

    var themeModal = document.querySelector('.shopify-section--main-product x-modal[id^="size-chart-"]');
    e.preventDefault();

    if (openModal(themeModal) || openModal(fallbackModal)) return;

    buildFallback(a.href)
      .then(function (m) { requestAnimationFrame(function () { if (!openModal(m)) window.location.href = a.href; }); })
      .catch(function () { window.location.href = a.href; });
  }, true);
})();

/* ─────────────────────────────────────
   BEDEN TABLOSU — inc kaldir + cm notu (2026-09-26)
   Tablo mağazadaki /pages/beden-tablosu sayfasindan geliyor ("86cm / 33.8").
   Sayfa verisine dokunmadan: hucrelerdeki "/ inc" kismi silinir,
   tablonun altina "Ölçü birimi cm'dir." notu eklenir.
   ───────────────────────────────────── */
(function () {
  if (window.__maiusSizeChartClean) return;
  window.__maiusSizeChartClean = true;

  var CELL = /^\s*(\d+(?:[.,]\d+)?\s*cm)\s*\/\s*\d+(?:[.,]\d+)?\s*(?:in(?:ch)?|")?\s*$/i;

  function noteText() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('en') === 0 ? 'All measurements are in cm.' : "Ölçü birimi cm'dir.";
  }

  function clean(modal) {
    if (!modal || modal.getAttribute('data-maius-clean') === '1') return;
    var tables = modal.querySelectorAll('table');
    if (!tables.length) return;
    tables.forEach(function (table) {
      table.querySelectorAll('td, th').forEach(function (cell) {
        var m = cell.textContent.match(CELL);
        if (m) cell.textContent = m[1].replace(/\s+/g, '');
      });
      var anchor = table.closest('.rte__table-wrapper') || table.closest('.table-scroller') || table;
      if (!anchor.parentNode.querySelector(':scope > .maius-size-chart-note')) {
        var p = document.createElement('p');
        p.className = 'maius-size-chart-note';
        p.textContent = noteText();
        anchor.parentNode.insertBefore(p, anchor.nextSibling);
      }
    });
    modal.setAttribute('data-maius-clean', '1');
  }

  function cleanAll() {
    document.querySelectorAll('x-modal[id^="size-chart-"], #maius-size-chart-fallback').forEach(clean);
  }

  /* Varyant degisince tema bolumu yeniden basiyor: acilistan hemen once her seferinde kontrol et */
  document.addEventListener('click', function () { cleanAll(); requestAnimationFrame(cleanAll); setTimeout(cleanAll, 400); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanAll);
  else cleanAll();
})();

/* ─────────────────────────────────────
   TÜRKÇE BÜYÜK HARF (2026-09-26)
   Sayfa İngilizce açılınca (/en/) tarayıcı büyük harfe çevirirken İngilizce kuralı
   uygular: "Öneri" -> "ÖNERI" olur. Türkçe metin taşıyan büyük harfli öğelere
   lang="tr" verilir, böylece "ÖNERİ", "YENİ" doğru yazılır. İngilizce metinlere
   dokunulmaz ("SIGN IN" SİGN İN olmasın diye). Türkçe sayfada (lang=tr) iş yapmaz.
───────────────────────────────────── */
(function () {
  if ((document.documentElement.lang || '').toLowerCase().indexOf('tr') === 0) return;
  var TR_HARF = /[çğıöşüÇĞİÖŞÜ]/;
  var TR_KELIME = /(^|[^a-zçğıöşü])(yeni|gelenler|elbise|elbiseler|giyim|aksesuar|aksesuarlar|etek|bluz|pantolon|pantolonlar|takim|takimlar|ceket|incele|indirim|sezon|koleksiyon|koleksiyonu|ile|ve|siparis|siparisler|kargo|beden|renk|detaylari|tesettur|abiye|ceketler|yelek|tunik|kimono|sepet|sepete|ekle|git|devam|et|favoriler|giris|hesabim|iletisim|hakkimizda|kampanya|firsat|son|gun|gunu|stoklarla|sinirlidir|bizi|takip|edin|cok|satanlar|yakinda|siyah|beyaz|kemik|desenli|desen|bej|beji|pudra|kahve|mavi|mavisi|bebek|zikzak|renkli|cizgili|lacivert|bordo|ekru|haki|yesil|kirmizi|mor|sari|turuncu|pembe|gri|vizon|taba|krem|kum|tas|antrasit|lila|mint|fildisi|stok|stoktakiler|sadece)(?![a-zçğıöşü])/i;
  function turkceMi(metin) {
    return TR_HARF.test(metin) || TR_KELIME.test(metin);
  }
  function isle(kok) {
    var ogeler = (kok || document.body).querySelectorAll('*');
    for (var i = 0; i < ogeler.length; i++) {
      var e = ogeler[i];
      if (e.hasAttribute('lang') || e.closest('[lang]:not(html)')) continue;
      var metin = '';
      for (var n = e.firstChild; n; n = n.nextSibling) if (n.nodeType === 3) metin += n.nodeValue;
      metin = metin.trim();
      if (!metin || !/i/.test(metin)) continue;
      var tt = getComputedStyle(e).textTransform;
      if (tt !== 'uppercase' && tt !== 'capitalize') continue;
      if (turkceMi(metin) || turkceMi(e.textContent || '')) e.setAttribute('lang', 'tr');
    }
  }
  var zamanlayici = null;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', planla);
  else planla();
  var bekleyen = [];
  function planla(mutasyonlar) {
    if (mutasyonlar) for (var m = 0; m < mutasyonlar.length; m++) if (mutasyonlar[m].target && mutasyonlar[m].target.nodeType === 1) bekleyen.push(mutasyonlar[m].target);
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(function () {
      var kokler = bekleyen.length ? bekleyen.splice(0) : [document.body];
      for (var i = 0; i < kokler.length; i++) { if (document.contains(kokler[i])) { isle(kokler[i]); if (kokler[i].nodeType === 1 && !kokler[i].hasAttribute('lang')) isle_tek(kokler[i]); } }
    }, 150);
  }
  function isle_tek(e) { isle({ querySelectorAll: function () { return [e]; } }); }
  new MutationObserver(planla).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ─────────────────────────────────────
   MOBİL SOL MENÜ ANİMASYONSUZ (2026-09-26)
   Tema menüyü (header-sidebar) soldan kaydırarak açıyor, linkleri sırayla
   beliriyor, alt menüye geçerken soldurma yapıyor. Hepsi Element.animate (WAAPI)
   ile çalışıyor: menünün içindeki (gölge DOM parçaları dahil) her animasyonun
   süresi ve gecikmesi 0 yapılır, yani menü ve alt menüler anında açılıp kapanır.
   theme.js değiştirilmedi.
───────────────────────────────────── */
(function () {
  var asil = Element.prototype.animate;
  if (!asil || asil.__maiusMenu) return;
  function menudeMi(el) {
    var n = el;
    while (n) {
      if (n.nodeType === 1 && n.matches && n.matches('header-sidebar, header-sidebar-collapsible-panel')) return true;
      var p = n.parentNode;
      n = p && p.nodeType === 11 ? p.host : p;
    }
    return false;
  }
  var yeni = function (keyframes, options) {
    if (menudeMi(this)) {
      if (typeof options === 'number' || options == null) options = { duration: 0 };
      else options = Object.assign({}, options, { duration: 0, delay: 0, endDelay: 0 });
    }
    return asil.call(this, keyframes, options);
  };
  yeni.__maiusMenu = true;
  Element.prototype.animate = yeni;
})();

/* ─────────────────────────────────────
   ÜRÜN ADINDA "MAIUS" YOK (2026-09-26)
   Kartlarda Liquid ile (snippets/urun-adi.liquid) siliniyor. Diğer ekranlarda
   (ürün sayfası başlığı, sepet çekmecesi/sayfası satırları, stok bildirimi,
   birlikte al, hızlı satın al) burada siliniyor. Ürün verisine dokunulmaz.
   İngilizce çeviride "Maius" -> "May" olmuş; baştaki "May " de atılır.
───────────────────────────────────── */
(function () {
  var SECICI = '.product-card .product-title, .product-info .product-title, .product-title, .maius-cd-item__title, .maius-cp-item__title, .maius-cd-rec__title, .back-in-stock-modal__subtitle, .fbt__item-title, .line-item .h6 a, .line-item a.h6, .line-item p.h6, .product-sticky-bar .h6';
  function temizle(s) {
    return s.replace(/\s*\bmaius\b\s*/gi, ' ').replace(/^\s*may\s+/i, '').replace(/\s{2,}/g, ' ').trim();
  }
  function isle() {
    var el = document.querySelectorAll(SECICI);
    for (var i = 0; i < el.length; i++) {
      var e = el[i];
      for (var n = e.firstChild; n; n = n.nextSibling) {
        if (n.nodeType !== 3 || !n.nodeValue.trim()) continue;
        var v = n.nodeValue;
        if (!/\bmaius\b/i.test(v) && !/^\s*may\s+/i.test(v)) continue;
        var bas = v.match(/^\s*/)[0], son = v.match(/\s*$/)[0];
        n.nodeValue = bas + temizle(v) + son;
      }
    }
  }
  var z = null;
  function planla() { clearTimeout(z); z = setTimeout(isle, 30); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', isle); else isle();
  new MutationObserver(planla).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ─────────────────────────────────────
   MOBİL STICKY SEPETE EKLE ÇUBUĞU (2026-09-27 denetim)
   Prestige'in <product-sticky-bar> bileşeni var ve şablon ayarı açık, ama hiç
   görünmüyordu: theme.js ana <form> elemanını gözlüyor, o form ise boyutsuz
   (0x0, butonlar form= özniteliğiyle dışarıda) olduğu için "form ekranın
   üstünden çıktı" şartı (bottom < 0) hiç sağlanmıyor. theme.js'e dokunmadan
   gözlemi gerçek Sepete Ekle butonuna bağlıyoruz: buton ekrandan yukarı
   çıkınca çubuk açılır, footer görünürken kapanır.
───────────────────────────────────── */
(function () {
  if (!('IntersectionObserver' in window)) return;
  function kur(bar) {
    if (bar.dataset.maiusSticky) return;
    var formId = bar.getAttribute('form');
    var buton = document.querySelector('product-form button[type="submit"][form="' + formId + '"], .product-info buy-buttons button[type="submit"], .product-info button[type="submit"]');
    var footer = document.querySelector('.shopify-section--footer');
    if (!buton) return;
    bar.dataset.maiusSticky = '1';
    var butonGecti = false, footerGorunur = false;
    function uygula() { bar.classList.toggle('is-visible', butonGecti && !footerGorunur); }
    new IntersectionObserver(function (girdiler) {
      girdiler.forEach(function (g) {
        if (g.target === buton) butonGecti = !g.isIntersecting && g.boundingClientRect.bottom < 0;
        else if (g.target === footer) footerGorunur = g.isIntersecting;
      });
      uygula();
    }, { threshold: 0 }).observe(buton);
    if (footer) {
      new IntersectionObserver(function (girdiler) { girdiler.forEach(function (g) { footerGorunur = g.isIntersecting; }); uygula(); }, { threshold: 0 }).observe(footer);
    }
  }
  function tara() { document.querySelectorAll('product-sticky-bar').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tara); else tara();
  document.addEventListener('product:rerender', tara);
  new MutationObserver(function () { tara(); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
